import { Component } from '@angular/core';

@Component({
  selector: 'app-notams',
  standalone: true,
  imports: [],
  templateUrl: './notams.component.html',
  styleUrl: './notams.component.scss'
})
export class NotamsComponent {

}
